import webContextProvider from "../../providers/webContextProvider";

const limit = 20;
const recommendationsEndpoint =
  "/api/customer/recommendation/v4/customer/me/alike";

export default ({ productId }) => {
  const {
    storeId: store,
    browseLanguage,
    browseCurrency,
    browseCountry
  } = webContextProvider();

  const qs = `?limit=${limit}&store=${store}&lang=${browseLanguage}&currency=${browseCurrency}&country=${browseCountry}&type=ymal&expand=products&productids=${productId}`;

  return `${recommendationsEndpoint}${qs}`;
};
